module.exports = __webpack_public_path__ + "static/media/icon-toggle-datepicker.1e80bf46.svg";